const IMAGES = {
    logo: require('../assets/images/logo.png'),
    logoGreen: require('../assets/images/logo-green.png'),
    dummy: require('../assets/images/dummy.png'),
    stores: require('../assets/images/stores.webp'),
    register: require('../assets/images/register.webp'),
    avatar: require('../assets/images/avatar.png'),
    logoBlack: require('../assets/images/logo-black.png'),
    howItWorks1: require('../assets/images/how-works-1.webp'),
    howItWorks2: require('../assets/images/how-works-2.webp'),
    howItWorks3: require('../assets/images/how-works-3.webp'),
    howItWorks4: require('../assets/images/how-works-4.webp'),
    oxbowBuilding: require('../assets/images/oxbow-building.webp'),
    oxbowLogo: require('../assets/images/oxbow-logo.webp'),
    contactImg: require('../assets/images/contact-img.webp'),
    equipmentRentals: require('../assets/images/equipment-rentals.webp'),
    aboutHero: require('../assets/images/about-hero.webp'),
    customerJourney: require('../assets/images/customer-journey.webp'),
    growth: require('../assets/images/growth.png'),
    analytics: require('../assets/images/analytics.webp'),
    aboutQuickScan: require('../assets/images/about-quick-scan.webp'),

}

export {
    IMAGES,
}